import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import conciergeApiClient from 'Services/Apis/Concierge/conciergeApiClient';

export const getRequestCategoryThunk = createAsyncThunk(
    `RequestCategorySlicer/getRequestCategoryThunk`,
    async (flowId, { getState }) => {
        const { user } = getState().oidc;

        const headers = {
            Authorization: `Bearer ${user.access_token}`,
            campaignId: user.profile['custom:campaign_id'],
            catalogId: user.profile['custom:catalog_id'],
            participantId: user.profile['custom:participant_id'],
            username: user.profile.username || user.profile['custom:login'],
        };

        const { data } = await conciergeApiClient.get(`Category?flowExternalId=${flowId}`, { headers });
        return data;
    }
);

const initialState = {
    dataRequestCategory: [],
    loadingRequestCategory: false,
    errorRequestCategory: false,
};

const RequestCategorySlicer = createSlice({
    name: 'requestCategory',
    initialState,
    reducers: {
        resetDataRequestCategory: (state) => {
            state.dataRequestCategory = [];
            state.loadingRequestCategory = false;
            state.errorRequestCategory = false;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getRequestCategoryThunk.pending, (state) => {
            state.dataRequestCategory = [];
            state.loadingRequestCategory = true;
            state.errorRequestCategory = false;
        });
        builder.addCase(getRequestCategoryThunk.fulfilled, (state, action) => {
            state.loadingRequestCategory = false;
            state.dataRequestCategory = action.payload;
            state.errorRequestCategory = false;
        });
        builder.addCase(getRequestCategoryThunk.rejected, (state) => {
            state.loadingRequestCategory = false;
            state.errorRequestCategory = true;
            state.dataRequestCategory = [];
        });
    },
});

export const { resetDataRequestCategory } = RequestCategorySlicer.actions;
export default RequestCategorySlicer.reducer;